<template>
    <body class="min-h-fullscreen bg-home center-vh p-20" data-overlay="7">

        <div class="card px-50 py-30 w-400px mb-0">
            <div class="text-center">
                <img class="mb-10 logo-fitila" src="../../assets/static/fitila.png" alt="logo icon">
            </div>
            <h5 class="text-uppercase mt-20">Reset Password</h5>
            <p>Kindly enter your new password</p>
            <form class="form-type-line">
                    <div class="form-group">
                        <label for="password">Password</label>
                        <input type="password" class="form-control" id="password" @blur="$v.password.$touch()" v-model="password">
                        <div v-if="$v.password.$dirty">
                        <div class="custom-error" v-if="!$v.password.required">*You need to set a password.</div>
                        <div
                            class="custom-error"
                            v-if="!$v.password.minLength"
                        >*Password must be at least {{$v.password.$params.minLength.min}} characters.</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="confirm_password">Confirm Password</label>
                        <input type="password" class="form-control" id="confirm_password"  @blur="$v.confirm_password.$touch()" v-model="confirm_password">
                        <div v-if="$v.confirm_password.$dirty">
                        <div
                            class="custom-error"
                            v-if="!$v.confirm_password.sameAsPassword"
                        >*Passwords do not match.</div>
                        </div>
                    </div>

                <div class="form-group">
                    <button class="btn btn-bold btn-block btn-primary" disabled v-if="loading">
                        <circle-spin class="m-0"></circle-spin>
                    </button>
                    <button class="btn btn-bold btn-block btn-primary" type="button" v-else :disabled="$v.$invalid" @click="resetPassword">Reset</button>
                </div>
            </form>
        </div>
    </body>
</template>


<script>
import axios from "axios";
import {
  required,
  minLength,
  sameAs
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      loading: false,
      cipher: null,
      password: "",
      confirm_password: ""
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(8)
    },
    confirm_password: {
      sameAsPassword: sameAs("password")
    }
  },
  methods: {
      resetPassword() {
          this.loading = true
          let userData = {
              cipher: this.cipher,
              password: this.password
          }
          axios.patch('/users/reset/password', userData)
          .then( res => {
                this.loading= false
                this.$notify({
                    group: 'response',
                    type: 'success',
                    title:`${res.data.data}. You can now log in with your new password.`,
                    duration: 2500,
                });
                setTimeout(() => {
                    this.$router.push('/')
                }, 3000)
          })
          .catch(err => {
                this.loading= false
                this.$notify({
                group: 'response',
                type: 'error',
                title: 'Failed to reset. Please try again',
                duration: 5000       
                });
            })
      }
  },
  mounted() {
      this.cipher = this.$route.params.cipher
  }
}
</script>
